<template>
  <v-container>
    <v-card outlined>
      <v-snackbar :timeout="timeout" :top="y === 'top'" v-model="snackbar">
        {{ text }}
        <v-btn @click="snackbar = false" color="red" text>
          Fermer
        </v-btn>
      </v-snackbar>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Utilisateurs</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-btn color="#F44336" dark depressed large
        >
          <download-csv :data="users" name="users.csv">
            Télécharger CSV
          </download-csv>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field :id="dynamicID()"
                      append-icon="search"
                      hide-details
                      label="Rechercher..."
                      single-line
                      v-model="search"
        ></v-text-field>
      </v-card-title>

      <v-data-table
          :expanded.sync="expanded"
          :headers="headers"
          :items="users"
          :items-per-page="10"
          :loading="true"
          :search="search"
          :single-expand="singleExpand"
          dense
          no-data-text="Aucun résultat"
          no-results-text="Aucun résultat"
          show-expand
      >
        <v-progress-linear
            color="#01579B"
            indeterminate
            slot="progress"
            v-show="progressBar"
        ></v-progress-linear>
        <template v-slot:[`top`]>
          <v-toolbar color="white" flat>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog max-width="500px" v-model="dialog">
              <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                        v-slot:[`activator`]="{ on }">
                <v-btn class="mb-2" color="#009688" dark depressed large v-on="on">
                  <v-icon class="mr-2">mdi-plus-circle-outline</v-icon>
                  Nouvel utilisateur
                </v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="6" sm="6">
                        <v-select
                            :items="roles"
                            label="Role"
                            v-model="editedItem.userRoles"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field :id="dynamicID()"
                                      label="Email"
                                      v-model="editedItem.accountEmail"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12" sm="12">
                        <v-text-field :id="dynamicID()"
                                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                      :type="show1 ? 'text' : 'password'"
                                      @click:append="show1 = !show1"
                                      label="Mot de passe"
                                      v-model="editedItem.accountPassword"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="close" dark dense depressed style="background:#F5F5F5"
                  >Annuler
                  </v-btn
                  >
                  <v-btn
                      @click="saveData"
                      color="#01579B"
                      dark
                      depressed
                      outlined
                      type="submit"
                  >Sauvegarder
                  </v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon @click="deleteItem(item)" small>
            delete
          </v-icon>
        </template>
        <template v-slot:[`expanded-item`]="{ headers, item }">
          <td :colspan="headers.length">
            <vue-json-pretty :data="item"></vue-json-pretty>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "../../config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  props: {
    format: {
      type: String,
      default: "YYYY-MM-DD HH:mm:ss",
    },
    timePickerFormat: {
      type: String,
      default: "24hr",
    },
  },
  data() {
    return {
      isMobile: isMobileDevice(),
      dialog: false,
      search: "",
      progressBar: true,
      users: [],
      headers: [
        {text: "Id", value: "id", align: "left"},
        {text: "Date ", value: "createdDate", align: "left"},
        {text: "Role", value: "userRoles", align: "left"},
        {text: "Email", value: "accountEmail"},
        {text: "Désactivité", value: "isDisabled"},
        {text: "Actions", value: "action"},
      ],
      editedIndex: -1,
      editedItem: {
        userRoles: "",
        accountEmail: "",
        accountPassword: "",
      },
      status: ["Y", "N"],
      snackbar: false,
      text: "",
      timeout: 2000,
      show1: false,
      expanded: [],
      singleExpand: true,
      x: null,
      y: "top",
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    users() {
      this.progressBar = false;
    },
  },
  computed: {
    roles() {
      const roles = ["USER", "ADMINISTRATOR", "READER", "TPE"];
      return roles;
    },
    formTitle() {
      return this.editedIndex === -1
          ? "Ajouter un utilisateur"
          : "Editer un utilisateur";
    },
    formIsValid() {
      return (
          this.editedItem.userRoles !== "" &&
          this.editedItem.accountPassword !== "" &&
          this.editedItem.accountEmail !== ""
      );
    },
  },
  created() {
    apiClient
        .get(`${this.$store.getters.user.baseUrl}/account/users/lamine`)
        .then(response => {
          this.users = response.data.datas;
        })
        .catch(() => {
        });
  },

  methods: {
    editItem(item) {
      this.dialog = true;
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    deleteItem(item) {
      const index = this.users.indexOf(item);
      if (confirm("Are you sure you want to delete this user?")) {
        apiClient
            .delete(`${this.$store.getters.user.baseUrl}/account/users` + item.id)
            .then(() => {
              this.snackbar = true;
              this.text = "user delete";
              this.users.splice(index, 1);
            })
            .catch(() => {
              this.snackbar = false;
            });
      }
    },
    close() {
      this.dialog = false;
      this.userRoles = "";
      this.accountEmail = "";
      this.accountPassword = "";
    },
    saveData() {
      if (this.editedIndex > -1) {
        Object.assign(this.users[this.editedIndex], this.editedItem);
      } else {
        if (!this.formIsValid) {
          return;
        }
        const user = {
          accountEmail: this.editedItem.accountEmail,
          accountPassword: this.editedItem.accountPassword,
          userRoles: this.editedItem.userRoles,
        };
        apiClient
            .post(`${this.$store.getters.user.baseUrl}/account/users`, user)
            .then(() => {
              this.snackbar = true;
              this.text = "Utilisateur ajouté";
              this.dialog = false;
            })
            .catch(error => {
              this.snackbar = false;
              this.text = error;
            });
      }
    },
  },
};
</script>
